export default  {
    data () {
        return {}
    },
    methods: {},
    mounted () {},
    render (h) {
        return h('div', { attrs: { id: 'youtubeScreenIframeWrapperId' }, style: {
            width: '100%', height: '100%', display: 'none'
        } })
    }
}
